import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import EquipmentTypeParameterForm from "components/equipmentTypes/parameters/EquipmentTypeParameterForm";
import { updateEquipmentTypeParameter } from "graphql/mutations";
import {
  getEquipmentType,
  getEquipmentTypeParameter,
  listEquipmentTypeParameters,
} from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentTypeParameterUpdateForm = ({
  equipmentTypeID,
  equipmentTypeParameterId,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [equipmentTypeParameter, setEquipmentTypeParameter] = useState();
  const [companies, setCompanies] = useState([]);

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { parameterID, parameterValue } = valuesParam;

      if (equipmentTypeParameter.parameterID !== parameterID) {
        const oldEquipmentTypeParameterData = await API.graphql(
          graphqlOperation(listEquipmentTypeParameters, {
            filter: {
              and: [
                {
                  equipmentTypeID: {
                    eq: equipmentTypeParameter.equipmentTypeID,
                  },
                },
                {
                  parameterID: { eq: parameterID },
                },
              ],
              deletedAt: { attributeExists: false },
            },
          })
        );
        const oldEquipmentTypeParameterItems =
          oldEquipmentTypeParameterData.data.listEquipmentTypeParameters.items;

        if (oldEquipmentTypeParameterItems.length > 0) {
          toast.error(strings.parameterExists);
          return;
        }
      }

      await API.graphql({
        query: updateEquipmentTypeParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            id: equipmentTypeParameterId,
            parameterID,
            parameterValue,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/equipmentTypes");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchEquipmentTypeParameter(id) {
    try {
      const equipmentTypeParameterData = await API.graphql(
        graphqlOperation(getEquipmentTypeParameter, { id })
      );
      const equipmentTypeParameterItem =
        equipmentTypeParameterData.data.getEquipmentTypeParameter;
      if (!equipmentTypeParameterItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/equipmentTypes");
        return;
      }
      setEquipmentTypeParameter({
        ...equipmentTypeParameterItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  async function getCompaniesFromEquipmentType(id) {
    try {
      const equipmentTypeData = await API.graphql(
        graphqlOperation(getEquipmentType, { id })
      );
      const equipmentTypeItem = equipmentTypeData.data.getEquipmentType;
      if (!equipmentTypeItem) {
        toast.error(strings.responses.errorFetchEquipmentType);
        return;
      }
      setCompanies(equipmentTypeItem.companies);
    } catch (err) {
      toast.error(strings.responses.errorFetchEquipmentType);
    }
  }

  useEffect(() => {
    fetchEquipmentTypeParameter(equipmentTypeParameterId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentTypeParameterId]);

  useEffect(() => {
    getCompaniesFromEquipmentType(equipmentTypeID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentTypeID]);

  if (!equipmentTypeParameter || !companies || companies?.length <= 0)
    return <Loader />;

  return (
    <div>
      <EquipmentTypeParameterForm
        onSubmit={onSubmit}
        type="update"
        initialValues={equipmentTypeParameter}
        companies={companies}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Parámetro de Tipo de Equipo",
    successUpdated: "Parámetro de Tipo de Equipo actualizado con éxito",
    parameterExists: "El parámetro ya existe en el tipo de equipo",
    responses: {
      errorFetch: "Error al consultar el parámetro de tipo de equipo",
      errorFetchEquipmentType: "Error al consultar tipo de equipo",
    },
  },
});

export default EquipmentTypeParameterUpdateForm;
